
import { defineComponent } from '@vue/composition-api';
import Icon from '../icons.vue';
import { removeParentheses } from '@/composables/utils';

export default defineComponent({
  name: 'IllinoisCartItem',
  components: {
    Icon
  },
  props: {
    outcomeName: {
      type: String,
      required: true
    },
    marketName: {
      type: String,
      required: true
    },

    eventName: {
      type: String,
      required: true
    },
    oddValue: {
      type: String,
      required: true
    },
    uniqueId: {
      type: String,
      required: true
    },
    specifier: {
      type: String,
      required: false
    },
    isCartOpen: {
      type: Boolean,
      default: false
    },
    betType: {
      type: String,
      default: ''
    },
    changed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    t(key: string) {
      return this.$t(key);
    },
    removeOdd() {
      this.$store.dispatch('cart/removeOddFromCart', {
        unique_id: this.uniqueId
      });
    },
    async toggleFixedBase() {
      await this.$store.dispatch('cart/checkFixedBaseSystem', {
        unique_id: this.uniqueId
      });
    },
    removeParentheses
  },
  computed: {
    isFixedBase(): boolean {
      const getBet = this.$store.getters['cart/getBet'];
      if (
        !getBet ||
        !getBet._system_detail ||
        !getBet._system_detail.fixed_bases
      ) {
        return false;
      }
      return getBet._system_detail.fixed_bases.includes(this.uniqueId);
    },
    showFixedBaseButton(): boolean {
      return this.isCartOpen && this.betType === 'system';
    },
    debugMode(): boolean {
      return process.env.VUE_APP_DEBUG_MODE === 'true';
    },
    oddsToUpdate(): any[] {
      return this.$store.getters['IllinoisSport/getOddsToUpdate'] || [];
    },
    isOddUpdated(): boolean {
      const updateItem = this.oddsToUpdate.find(
        (item: any) => item.source === this.uniqueId
      );
      return (
        updateItem &&
        (updateItem.reason === 'changed_odd_value' ||
          updateItem.reason === 'changed_multiplicity')
      );
    },
    isOddDisabled(): boolean {
      const updateItem = this.oddsToUpdate.find(
        (item: any) => item.source === this.uniqueId
      );
      return updateItem && updateItem.reason === 'disabled';
    }
  }
});
